import { useDocumentResolverContext } from '../contexts/DocumentResolverContext/hooks/useDocumentResolverContext.hook';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDocIncrementGeneration = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<number> => {
  const { printerSettings } = useDocumentResolverContext();

  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isLoading: false,
      isSuccess: false,
    };
  }

  return {
    data: { generated: printerSettings?.pdfPrintsIncrement ?? 0 },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
